import {showError} from "./main";
import { fetchAuthSession } from 'aws-amplify/auth';
import { get as amplifyGet, post as amplifyPost, put as amplifyPut, del as amplifyDel , patch as amplifyPatch} from 'aws-amplify/api';


const createInit = async (body) => {
    let session = null;

    try{
        session = await fetchAuthSession();
    }catch (e){

    }

    let myInit = {
        headers: {
        },
    };

    if(!!session?.tokens?.idToken){
        myInit.headers["Authorization"] = `Bearer ${session.tokens.idToken.toString()}`;
    }

    if (body != null) {
        myInit["body"] = body;
    }

    return myInit;
}

const toJson = async (data) => {
    const text = await data?.text();

    if(!text){
        return null;
    }

    return JSON.parse(text);
}

export const expiredEntryLinkMessage = "Der Einstiegslink ist abgelaufen. Wenden Sie sich bitte per Mail info@keydirect.at mit Ihrer Anfrage / Bestellnummer, wenn Sie weitere Informationen benötigen";

export const getResponseStatus = (error) => {
    return error?.response?.statusCode || error?.response?.status || error?.$metadata?.httpStatusCode;
}

export const getResponseBody = (error) => {
    const body = error?.response?.data || error?.response?.body;

    if (!body) {
        return null;
    }

    if (typeof body !== "string") {
        return body;
    }

    try {
        return JSON.parse(body);
    } catch {
        return body;
    }
}

export const handleExpiredEntryLinkError = (error) => {
    if (getResponseStatus(error) !== 410) {
        return false;
    }

    showError(expiredEntryLinkMessage);
    return true;
}

export const handleApiError = (error) => {
    showError("Fehler bei Serverkommunikation: " + error);
}

export const get = async (path, handleError = true, api = "key-direct-api") => {
    const init = await createInit(null);
    try {
        return await toJson((await amplifyGet({apiName:api, path: path, options: init}).response).body); //.catch wouldn't work, because afterwards .then would be called, because chain would be marked as resolved.
    } catch (error) {
        if(handleError) {
            handleApiError(error);  // rethrow, because when async method ends without exception .then is called, but we don't want that
        }
        throw error;
    }
}

export const del = async (path, handleError = true, api = "key-direct-api") => {
    const init = await createInit(null);
    try {
        return await toJson((await amplifyDel({apiName:api, path: path, options: init}).response).body);
    } catch (error) {
        if (handleError){
            handleApiError(error);
        }
        throw error;
    }
}

export const post = async (path, body, handleError = true, apiName="key-direct-api") => {
    const init = await createInit(body);
    try {
        return await toJson((await amplifyPost({apiName:apiName, path: path, options: init}).response).body);
    } catch (error) {
        if (handleError){
            handleApiError(error);
        }
        throw error;
    }
}

export const patch = async (path, body, handleError = true, apiName="key-direct-api") => {
    const init = await createInit(body);
    try {
        return await toJson((await amplifyPatch({apiName:apiName, path: path, options: init}).response).body);
    } catch (error) {
        if (handleError){
            handleApiError(error);
        }
        throw error;
    }
}

export const put = async (path, body, handleError = true, apiName = "key-direct-api") => {
    const init = await createInit(body);
    try {
        return await toJson((await amplifyPut({apiName:apiName, path: path, options: init}).response).body);
    } catch (error) {
        if (handleError){
            handleApiError(error);
        }
        throw error;
    }
}
